import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import Modal from '@mui/material/Modal';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import EditIcon from '@mui/icons-material/Edit';
import './PlanesCotizacion.css'




const styleModalCotizador = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    height: 550,
    bgcolor: 'background.paper',
    border: 'none',
    borderRadius: '8px',
    boxShadow: '',
    p: 3,
};

export default function EditarPerfilCotizadorModal() {
    const dataObj = JSON.parse(sessionStorage.getItem("interContratante"))
    const [name, setName] = React.useState(dataObj.nombre);
    const [dateOfBirht, setDateOfBirth] = React.useState(dataObj.fechaNacimiento);
    const [phone, setPhone] = React.useState(dataObj.telefono);
    const [email, setEmail] = React.useState(dataObj.correo);

    const [Open, setOpenModalCotizador] = React.useState(false);
    const handleOpenModalCotizador = () => setOpenModalCotizador(true);
    const handleCloseModalCotizador = () => setOpenModalCotizador(false);
    const [genero, setGenero] = React.useState('');
    const [value, setValue] = React.useState(null);

    const handleChangeSelectGenero = (event) => {
        setGenero(event.target.value);
    };

    return (
        <div>
            <Button onClick={handleOpenModalCotizador}><EditIcon /></Button>
            <Modal
                open={Open}
                onClose={handleCloseModalCotizador}
            >
                <Box sx={styleModalCotizador}>
                    <h2 className="txt-principal-modal">
                        ¿Quieres editar la informaci&oacute;n
                        del asegurado titular?
                    </h2>
                    <TextField id="outlined-basic" value={name} label="Nombre" variant="outlined" sx={{ m: 1, minWidth: 440 }} />
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            label="Fecha de nacimiento"
                            value={dateOfBirht}
                            onChange={(newValue) => {
                                setValue(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} sx={{ m: 1, minWidth: 440 }} />}
                        />
                    </LocalizationProvider>
                    <TextField id="outlined-basic"  value={phone} label="Teléfono" variant="outlined" sx={{ m: 1, minWidth: 440 }} />
                    <TextField id="outlined-basic" value={email} label="E-mail" variant="outlined" sx={{ m: 1, minWidth: 440 }} />
                    <FormControl sx={{ m: 1, minWidth: 440 }}>
                        <InputLabel id="demo-simple-select-helper-label">G&eacute;nero</InputLabel>
                        <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            value={genero}
                            label="Age"
                            onChange={handleChangeSelectGenero}
                        >
                        </Select>
                    </FormControl>
                    <Button onClick={handleCloseModalCotizador} className="btn-cancelar-modal">Cancelar</Button>
                    <Button className="btn-guardar-modal">GUARDAR</Button>
                </Box>
            </Modal>
        </div>
    );
}
